import { Component, OnInit, Inject } from '@angular/core';
import { EventEmitter, Input, Output } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { ActionRecommendationService } from '../action-recommendations.service';
import { ActionRecommendationAttachRuleViewModel, ActionRecommendationsViewModel } from '../action-recommendations.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'action-recommendation-rule-quotes',
  templateUrl: './action-recommendation-rule-quotes.component.html',
  styleUrls: ['./action-recommendation-rule-quotes.component.scss']
})
export class ActionRecommendationRulesQuotesComponent implements OnInit {

  @Output() reloadSelectedQuote: EventEmitter<any> = new EventEmitter();
  @Input() inspectionId: number;
  @Input() quoteId: number;
  @Input() StartSMU: number;
  @Input() componentId: number;
  @Input() actionDate: Date;

  RuleDetails: ActionRecommendationsViewModel[] = [];
  _DataCount: number;
  loadingPossibleRecommendations: boolean;

  constructor(private _dialogRef: MatDialogRef<ActionRecommendationRulesQuotesComponent>,
    private _RuleService: ActionRecommendationService,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _notify: NotificationsService
  ) { }

  ngOnInit() {
    this.loadingPossibleRecommendations = true;
    this.inspectionId = this._data.inspectionId;
    this.quoteId = this._data.quoteId;
    this.componentId = this._data.componentId;
    this.StartSMU = this._data.StartSMU;
    this.actionDate = this._data.actionDate;
    this.getRulesToAttach();
  }

  closeModal() {
    this._dialogRef.close();
  }

  getRulesToAttach() {
    this.loadingPossibleRecommendations = true;
    this._RuleService.GetActionRecommendationRulesQuotes(this.inspectionId).subscribe(rec => {
      this._DataCount = rec.length;
      this.RuleDetails = rec;
      this.loadingPossibleRecommendations = false;
    }, err => {
      this._notify.error('Error', 'Unable to load possible recommendation. Please contact TrackTreads support!!');
      console.error(err);
      this.loadingPossibleRecommendations = false;
    });
  }

  addRuleComponent(ruleSelected: boolean, ruleId: number) {
    if (ruleSelected) {
      if (this.actionDate == undefined || this.actionDate == null) {
        //   this.RuleDetails.filter(x => x.RuleId === ruleId)[0].RuleSelected = false;
        this._notify.error('Error', 'Unable to add recommendation. Please select Date!!');
      }
      else if (this.StartSMU == undefined || this.StartSMU == 0) {
        //  this.RuleDetails.filter(x => x.RuleId === ruleId)[0].RuleSelected = false;
        this._notify.error('Error', 'Unable to add recommendation. Please enter SMU!!');
      }
      else {
        this.loadingPossibleRecommendations = true;
        const VM = new ActionRecommendationAttachRuleViewModel();
        VM.RuleId = ruleId;
        VM.InspectionId = this.inspectionId;
        VM.StartSMU = this.StartSMU;
        VM.QuoteId = this.quoteId;
        VM.ActionDate = this.actionDate;
        this._RuleService.AddActionRecommendationRulesQuotes(VM).subscribe(rec => {
          if (rec == 0) {
            this._notify.success('Added', "Rule added successfully.");
            //this.getRulesToAttach();
            this.RuleDetails.filter(x => x.RuleId === ruleId)[0].RuleAdded = true;
            this.loadingPossibleRecommendations = false;
          }
          else if (rec == 1) {
            this._notify.error('Failed', "Unable to add recommendation. No such component found!!");
            this.RuleDetails.filter(x => x.RuleId === ruleId)[0].RuleSelected = false;
            this.loadingPossibleRecommendations = false;
          }
          else if (rec == 2) {
            this._notify.error('Error', "Unable to add recommendation. Please contact TrackTreads support!!");
            this.RuleDetails.filter(x => x.RuleId === ruleId)[0].RuleSelected = false;
            this.loadingPossibleRecommendations = false;
          }
          this.reloadSelectedQuote.emit({
            quoteId: this.quoteId,
            recommendationId: 1
          });
        }, err => {
          this._notify.error('Error', 'Unable to add recommendation. Please contact TrackTreads support!!');
          this.RuleDetails.filter(x => x.RuleId === ruleId)[0].RuleSelected = false;
          this.loadingPossibleRecommendations = false;
        });
      }
    }

  }



}
